if($('#blog-filter-form').length) {

    let form = $("#blog-filter-form"),
        formFilters = form.find('select');

    formFilters.on('change', function() {
        form.submit();
    });

}
